import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "paymentsFilled"
const PaymentsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M20.223 5.651C21.3 5.82 22.125 6.751 22.125 7.875V17.625C22.125 18.868 21.118 19.875 19.875 19.875H7.125C6.01 19.875 5.085 19.065 4.906 18H6.476C6.606 18.224 6.848 18.375 7.125 18.375H19.875C20.289 18.375 20.625 18.039 20.625 17.625V7.875C20.625 7.598 20.474 7.355 20.25 7.226V6Q20.25 5.822 20.223 5.651" />
          <path
            fillRule="evenodd"
            d="M18 5.25C18.414 5.25 18.75 5.586 18.75 6V15.75C18.75 16.164 18.414 16.5 18 16.5H3.75C3.336 16.5 3 16.164 3 15.75V6C3 5.586 3.336 5.25 3.75 5.25zM10.875 7.875C9.218 7.875 7.875 9.218 7.875 10.875S9.218 13.875 10.875 13.875 13.875 12.532 13.875 10.875 12.532 7.875 10.875 7.875M5.625 10.125C5.211 10.125 4.875 10.461 4.875 10.875S5.211 11.625 5.625 11.625 6.375 11.289 6.375 10.875 6.039 10.125 5.625 10.125M16.125 10.125C15.711 10.125 15.375 10.461 15.375 10.875S15.711 11.625 16.125 11.625 16.875 11.289 16.875 10.875 16.539 10.125 16.125 10.125"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PaymentsFilledIcon
